var _rect, _circle, _path, _path2, _ellipse, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashTop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 8,
    fill: "#E0F2FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 19.5,
    r: 5,
    stroke: "#0284C7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 23.25C36.5711 23.25 38.25 21.8509 38.25 20.125C38.25 18.3991 36.5711 17 34.5 17",
    stroke: "#0284C7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 23.25C17.4289 23.25 15.75 21.8509 15.75 20.125C15.75 18.3991 17.4289 17 19.5 17",
    stroke: "#0284C7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 33.25,
    rx: 7.5,
    ry: 5,
    stroke: "#0284C7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 35.75C39.1928 35.2691 40.75 34.0513 40.75 32.625C40.75 31.1987 39.1928 29.9809 37 29.5",
    stroke: "#0284C7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 35.75C14.8072 35.2691 13.25 34.0513 13.25 32.625C13.25 31.1987 14.8072 29.9809 17 29.5",
    stroke: "#0284C7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashTop1);
export default __webpack_public_path__ + "static/media/dash-top-1.2306ea5d599d362d9b2c7072fa02ee8d.svg";
export { ForwardRef as ReactComponent };